"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizeStyle = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var BlockStyling_1 = require("./BlockStyling");
var BlockStyleStore_1 = require("Project/Stores/BlockStyleStore");
var CssEditor_1 = __importDefault(require("DreamCoat/StyleShortcut/CssEditor/CssEditor"));
var TextWidgetStyling_1 = require("./TextWidgetStyling");
var FilterableColorProvider_1 = require("Project/QwilrEditor/Styling/FilterableColorProvider");
var WidgetStyling_1 = require("./WidgetStyling");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var styles = __importStar(require("./CustomizeStyle.css"));
var CustomizeStyle = function (_a) {
    var _b;
    var currentlyAppliedStyleName = _a.currentlyAppliedStyleName, onBackClick = _a.onBackClick;
    var stylePermissionStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var blockStyleStore = blockStore.blockStyleStore;
    var blockStyle = (0, BlockStyleStore_1.getNonSourceBlockStyle)(blockStyleStore);
    var withBlockStyle = stylePermissionStore.allowStyle(Types_1.StyleAccessType.Block);
    var withTextStyle = stylePermissionStore.allowStyle(Types_1.StyleAccessType.Text);
    var withCssEditor = stylePermissionStore.shouldHaveCssEditor(!!((_b = blockStyle.css) === null || _b === void 0 ? void 0 : _b.length));
    (0, react_1.useEffect)(function () {
        telemetry.trackOnly("Block Styles Shortcuts Viewed", {}, {
            blockIntercom: true,
        });
    }, []);
    var tabsAndPanels = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read((0, utils_1.includeIf)(withBlockStyle, [
        {
            tab: "Block",
            tabPanel: react_1.default.createElement(BlockStyling_1.BlockStyling, null),
        },
    ])), false), __read((0, utils_1.includeIf)(withTextStyle, [
        {
            tab: "Text",
            tabPanel: react_1.default.createElement(TextWidgetStyling_1.TextWidgetStyling, null),
        },
    ])), false), __read((0, utils_1.includeIf)(usingFeature(FeatureFlag_1.default.WidgetBlockStylesUI), [
        {
            tab: "Widgets",
            tabPanel: react_1.default.createElement(WidgetStyling_1.WidgetsStyling, null),
        },
    ])), false), __read((0, utils_1.includeIf)(withCssEditor, [
        {
            tab: "CSS",
            tabPanel: (react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "l", paddingRight: "l" },
                react_1.default.createElement(CssEditor_1.default, { blockStyleStore: blockStyleStore }))),
        },
    ])), false);
    return (react_1.default.createElement(FilterableColorProvider_1.FilterableColorContextProvider, { blockStore: blockStore, brandStore: brandStore },
        react_1.default.createElement(kaleidoscope_1.Stack, { paddingTop: "s", gap: "xs", style: {
                maxHeight: "calc(75vh - var(--control-size-large) - var(--control-size-medium)",
            } },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", paddingLeft: "s", paddingRight: "s", gap: "xxs" },
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.ChevronLeft, null), onClick: onBackClick }),
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, truncate: true }, currentlyAppliedStyleName)),
            react_1.default.createElement(kaleidoscope_1.Tabs, { className: styles.tabs },
                react_1.default.createElement(kaleidoscope_1.TabList, { className: styles.tabsList, "aria-label": "Style types", align: kaleidoscope_1.TabListAlign.Start, isBordered: true }, tabsAndPanels.map(function (_a, index) {
                    var tab = _a.tab;
                    return (react_1.default.createElement(kaleidoscope_1.Tab, { key: index }, tab));
                })),
                react_1.default.createElement(kaleidoscope_1.TabPanels, { transitionHeight: true }, tabsAndPanels.map(function (_a, index) {
                    var tabPanel = _a.tabPanel;
                    return (react_1.default.createElement(kaleidoscope_1.TabPanel, { key: index }, tabPanel));
                }))))));
};
exports.CustomizeStyle = CustomizeStyle;
